import React, { useContext } from 'react'
import { Box } from '../../Components/Layout'
import { Header } from './components/TeamStats/Header'
import { MatchupContext } from '../../Context'
import { HeadToHeadContainer } from './components/HeadToHead/HeadToHeadContainer'
import { PreviousMatchups } from './components/PreviousMatchups/PreviousMatchups'
import { PlayersToWatch } from './components/PlayersToWatch'
import { TeamStatsComparison } from './components/TeamStats/TeamStatsComparison'
import { PregameProbabilitiesSection } from './components/fanResults/PregameProbabilitiesSection'
import { Goalie, Faceoff } from './components/PlayersToWatch'
import { STATS_YEAR } from '../../Config/League/league.config'
import { AdUnit } from '../../Components/Ads/AdUnit'
import { Con } from '../../Components/Layout/Containers/ConStyles'

export const Analysis: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { teams, eventInfo, isLoading, statLeaders } = useContext(MatchupContext)!

  if(isLoading) return null

  return (
    <>
      {teams.length <= 1 && (
        <>
          <Box boxColor="grey">
            <h3>Teams are not set for this matchup yet.</h3>
          </Box>
          <PregameProbabilitiesSection />
        </>
      )}
      {teams.length > 1 && (
        <>
          <Box noMargin boxColor="grey">
            <Header awayTeam={teams[0].data} homeTeam={teams[1].data} eventInfo={eventInfo} />
            <TeamStatsComparison
              year={eventInfo?.year || STATS_YEAR}
              seasonSegment={eventInfo?.seasonSegment}
              awayTeam={teams[0].data}
              homeTeam={teams[1].data}
            />
          </Box>
          <AdUnit bannerType="bannerSecond" aria-label="Matchup page ad second" />
          <PregameProbabilitiesSection />
          <HeadToHeadContainer />
          <Box boxColor="grey">
            {statLeaders.length > 0 && (
              <PlayersToWatch
                teamLeaders={statLeaders}
                awayId={teams[0].teamId}
                homeId={teams[1].teamId}
              />
            )}
          </Box>
          <AdUnit bannerType="bannerThird" aria-label="Matchup page ad third" />
          <Box padding={0} boxColor="grey">
            <Goalie />
          </Box>
          {eventInfo?.seasonSegment !== 'champseries' && (
            <Box padding={0} boxColor="grey">
              <Faceoff />
            </Box>
          )}
          <Box boxColor="grey">
            <PreviousMatchups />
          </Box>
          <Con vertMargins={10} />
        </>
      )}
    </>
  )
}
